<template>
	<div class="target flex justify-between">
		<div class="postion" v-for="(item,index) in targetList" :key="index">
			
			<div style="flex: 1;" class="back" >
				<div class="counts flex">
					{{item.counts}}
				</div>
				<p class="text">{{ item.text }}<span>&nbsp;{{ item.unit }}</span></p>
			</div>
			<img class="img" src="~@/assets/images/energyStorage/targetBg.png" alt="">
		</div>
	</div>
</template>
<script>

import { dataInterface } from '@/api/dataInterfaceApi'
import vehicleAll from '@/assets/images/comm/vehicleAll.png'
import carbonEmissionsAll from '@/assets/images/comm/carbonEmissionsAll.png'
import mileageAll from '@/assets/images/comm/mileageAll.png'
import electricityAll from '@/assets/images/comm/electricityAll.png'
export default {
	data() {
		return {
			timer: null,
			targetList: [
				{
					counts: '36',
					text:"预警数量",
					icon: vehicleAll,
					width: '90px',
          			unit: ''
				},
				{
					counts: '3340',
					text:"安全运营天数",
					icon: carbonEmissionsAll,
					width: '90px',
					unit: ''
				},
				// {
				// 	counts: '7780',
				// 	text:"二氧化碳减排",
				// 	icon: mileageAll,
				// 	height: '70px',
    //       			unit: 'kg'
				// },
				// {
				// 	counts: '44660',
				// 	text:"光伏发电占比",
				// 	icon: electricityAll,
				// 	height: '70px',
				// 	unit: '%'
				// }
			],
		};
	},
	components: {},
	props: {},
	watch: {},
  	destroyed() {
		this.$bus.$off('bigScreen::storedEnergyId')
		clearInterval(this.timer)
	},
	mounted() {
		this.timer = setInterval(()=>{
			this.yongdianliangleiji()
		}, 50000)
    	this.$bus.$on('bigScreen::storedEnergyId', ()=>{
			this.yongdianliangleiji()
		})
		this.yongdianliangleiji()
	},
	methods: {
		// // 初始化
		// getData(data) {
		// 	// 用电量累计
		// 	this.yongdianliangleiji(data)
		// },
		// 用电量累计
		yongdianliangleiji(data = {}) {
			let params = {}
			let query = this.$route.query
			params = {
				'enCode': 'chuneng-quanguo-jjaq',
				'@energyId': localStorage.getItem('bigScreen::storedEnergyId') || 'ES00001'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res) return
				// console.log(res)
				this.targetList[0].counts = res[0].alarm_total
				this.targetList[1].counts = res[0].safe_day
				
			})
			.catch((err) => {
				console.log(err);
			});
		}
	}
}
</script>
<style lang="scss" scoped>
@font-face {
  font-family: "HT";
  src: url("~@/assets/font/HT.ttf");
}
.postion{
	padding: 8px 5px;
	height: 120px;
	position: relative;
	.img{
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		z-index: -1;
	}
}
	
.target {
	
	width: 100%;
	height: 122px;
	display: flex;
	margin-top: 20px;
	padding: 0 230px;
	.postion:nth-child(1){
		background: url('~@/assets/images/energyStorage/target1.png') no-repeat;
		background-size: 84px 84px;
		background-position: 18px 18px;
	}
	.postion:nth-child(2){
		background: url('~@/assets/images/energyStorage/target2.png') no-repeat;
		background-size: 84px 84px;
		background-position: 18px 18px;
	}
	.postion {
		
		margin-top: 40px;
		width:380px;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-right: 20px;
		
		.pos-line {
			width: 6px;
			height: 62px;
		}
		.pos-logo {
			width: 32px;
			height: 32px;
			margin: 0 30px 0 15px;
		}
	}
 
 .icon {
 	width: 100px;
 	flex-shrink: 0;
 	display: flex;
 	align-items: center;
 	justify-content: center;
 }
 
 .counts {
	
 	font-size: 50px;
 	margin-left: 120px;
 	display: flex;
 	flex-direction: row;
 	align-items: center;
 	color: #FFC166;
 	height: 40px;
	  font-family: "HT";
 	// @include ffamily-HT;
 	.item_text {
 		font-size: 30px;
 		margin-top: 7px;
 		color: #fff;
 	}
 
 	.DS-Digital-Bold {
 		font-family: "DS-Digital-Bold";
 	}
 }
 
 .text {
 	margin-left: 120px;
 	font-size: 32px;
 	height:45px;
 	line-height: 60px;
 	white-space: nowrap;
 }
}
</style>